import {
	AspectRatio,
	Box,
	Flex,
	Heading,
	Image,
	List,
	ListIcon,
	ListItem,
	Stack,
	HStack,
	Button,
	Text,
	AlertDialog,
	AlertDialogBody,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogContent,
	AlertDialogOverlay,
	useToast,
	Badge,
	IconButton,
	Icon,
	SimpleGrid 
} from '@chakra-ui/react'

import {Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Select as ChakraSelect} from '@chakra-ui/react';
import { FiEdit } from 'react-icons/fi';
import { useEffect, useRef, useState } from 'react'
import {
	FaFacebook,
	FaInstagram,
	FaLinkedin,
	FaTwitter,
	FaYoutube,
} from 'react-icons/fa'
import { Link, useParams, useSearchParams } from 'react-router-dom'
import AdminBreadcrumb from '../../components/AdminBreadcrumb'
import { getRequest, postRequest } from '../../services/base.service'
import { useDispatch } from 'react-redux'
import { setAdminSidebarFalseOnUrlChange, setCurrentPageHeading } from '../../redux/common/commonActions'
import { useNavigate } from 'react-router-dom'

const AdminBusinessDetails = ({ usedAs }) => {
	const [breadCrumb] = useState([
		{ label: 'Dashboard', isCurrentPage: false, link: '/admin/dashboard' },
		{
			label: usedAs !== 'claim' ? 'Business List' : 'Claim List',
			isCurrentPage: false,
			link: `/admin/${usedAs !== 'claim' ? 'business-list' : 'claimed-list'}`,
		},
	])
	const [isLoading, setIsLoading] = useState(true)
	const [business, setBusiness] = useState(null)
	const [alertDialogIsOpen, setAlertDialogIsOpen] = useState(false)
	const [actionStatus, setActionStatus] = useState(null)
	const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
    const [status, setStatus] = useState(business?.status);
	const [isDeleted, setIsDeleted] = useState(false)

	const cancelRef = useRef()

	const params = useParams()
	const dispatch = useDispatch()
	const [searchParams] = useSearchParams()
	const toast = useToast()
	const navigate = useNavigate()

    const statuses = {
		pending: 'pending',
        approve: 'approved',
        decline: 'declined',
        block: 'blocked',
        unblock: 'unblocked',
    };

    const openStatusUpdateModal = () => setIsStatusModalOpen(true);
    const closeStatusUpdateModal = () => setIsStatusModalOpen(false);

	useEffect(() => {
		const { id } = params
		
		fetchBusinessDetails(id)
		dispatch(setCurrentPageHeading('Business Details'))
		dispatch(setAdminSidebarFalseOnUrlChange())
	}, [params, breadCrumb])

	const fetchBusinessDetails = (id) => {
		getRequest(`admin/businesses/${id}`)
			.then((res) => {
				setBusiness(res.result)
				setIsLoading(false)
			})
			.catch((error) => {
				setIsLoading(false)
				// console.log(error)
				if (
					usedAs === 'claim' &&
					error.response?.status === 404
				) {
					setIsDeleted(true)
				} else {
					console.error(error)
				}
			})
	}

	const objArrToStrArr = (objArr = [], keyName = 'name') => {
		return objArr.map((item) => item[keyName])
	}

	const showPricing = (qnt = 1) => {
		let dollarSigns = ''
		for (let i = 1; i <= qnt; i++) {
			dollarSigns = dollarSigns + '$'
		}
		return dollarSigns
	}

	const openConfirmDialog = (status) => {
		setActionStatus(status)
		setAlertDialogIsOpen(true)
	}

	const hideConfirmDialog = () => {
		setActionStatus(null)
		setAlertDialogIsOpen(false)
	}

	const handleConfirm = (status, business_id) => {
		postRequest(`admin/business/status/update`, { status, business_id })
			.then((res) => {
				
				hideConfirmDialog()
				toast({
					title: 'Status Changed.',
					description: res.message,
					status: 'success',
					duration: 5000,
					isClosable: true,
				})
				const { id } = params
				closeStatusUpdateModal();
				fetchBusinessDetails(id)
			})
			.catch((error) => {
				toast({
					title: 'Error',
					description: error.response.data.message || 'Something went wrong',
					status: 'error',
					duration: 5000,
					isClosable: true,
				})
			})
	}

	const setBadgeColorScheme = (status) => {
		let colorScheme

		if (status === 'approved') {
			colorScheme = 'green'
		} else if (status === 'pending') {
			colorScheme = 'yellow'
		} else {
			colorScheme = 'red'
		}

		return colorScheme
	}

	const handleStatusChange = () => {
		handleConfirm(status, business.id)
    }

	const validOperatingHours = business?.operating_hours?.filter(
		(item) => item?.start_time && item?.end_time
	);

	return (
		<>

{/* Status Edit Modal */}
			<Modal isOpen={isStatusModalOpen} onClose={closeStatusUpdateModal}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Edit Business Status</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <ChakraSelect value={status} onChange={(e) => setStatus(e.target.value)}>
						{Object.keys(statuses).map((key) => (
						<option key={key} value={key}>
							{statuses[key]}
						</option>
					))}
                        </ChakraSelect>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="blue" onClick={handleStatusChange}>Save</Button>
                        <Button variant="ghost" ml={2} onClick={closeStatusUpdateModal}>Cancel</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

<Modal isOpen={isDeleted} onClose={() => {}}>
	<ModalOverlay />
	<ModalContent>
		<ModalHeader>Business Deleted</ModalHeader>
		<ModalCloseButton display="none" />
		<ModalBody>
			<Text>This business has been deleted.</Text>
		</ModalBody>
		<ModalFooter>
			<Button
				colorScheme="blue"
				// onClick={() => {
				// 	window.location.href = '/admin/claimed-list'
				// }}
				onClick={() => navigate('/admin/claimed-list')}
			>
				Go to Claimed List
			</Button>
		</ModalFooter>
	</ModalContent>
</Modal>


			{!isLoading && (
				<AdminBreadcrumb
					items={[
						...breadCrumb,
						{ label: business?.name, isCurrentPage: true },
					]}
				/>
			)}

			<Box py={8}>
				<AlertDialog
					isOpen={alertDialogIsOpen}
					leastDestructiveRef={cancelRef}
					onClose={hideConfirmDialog}
				>
					<AlertDialogOverlay>
						<AlertDialogContent>
							<AlertDialogHeader fontSize="lg" fontWeight="bold">
								Confirmation
							</AlertDialogHeader>

							<AlertDialogBody>
								Are you sure? You can't undo this action afterwards.
							</AlertDialogBody>

							<AlertDialogFooter>
								<Button ref={cancelRef} onClick={hideConfirmDialog}>
									Cancel
								</Button>
								<Button
									colorScheme={actionStatus === 'approve' ? 'green' : 'red'}
									onClick={() => handleConfirm(actionStatus, business.id)}
									ml={3}
								>
									Confirm
								</Button>
							</AlertDialogFooter>
						</AlertDialogContent>
					</AlertDialogOverlay>
				</AlertDialog>

				<Flex
					pb={6}
					borderBottomWidth={'1px'}
					borderBottomStyle={'solid'}
					borderBottomColor={'gray.300'}
					flexDirection={['column', 'column', 'column', 'row']}
					align={'center'}
					textAlign={'center'}
				>
					<AspectRatio w={'200px'} h={'200px'} ratio={1 / 1} bg={'gray.100'}>
						<Image
							w="100%"
							h="100%"
							objectFit={'contain'}
							p={3}
							src={business?.logo}
							alt={business?.name}
						/>
					</AspectRatio>

					<Box w={''} ps={[0, 0, 0, 6]}>
						<Flex
							justify={['center', 'center', 'center', 'space-between']}
							flexDirection={['column', 'column', 'column', 'row']}
							align={'center'}
						>
							 <Box textAlign={['center', 'center', 'center', 'left']}>
								<Heading as={'h2'} fontSize={'1.5rem'}>
									{business?.name}{' '}
									<Badge
										fontSize={'1rem'}
										py={'2px'}
										ms={4}
										colorScheme={setBadgeColorScheme(business?.status)}
									>
										{business?.status}
									</Badge>
									<Icon
										as={FiEdit}
										boxSize={4}
								
										right="0"
										cursor="pointer"
										onClick={openStatusUpdateModal}
									/>
								</Heading>
								{business?.is_claimed && (
									<Badge mt={2} ml={1} colorScheme="purple" fontSize="0.9rem">
										Claimed
									</Badge>
								)}
							</Box>
							<Box
								ps={'6'}
								textAlign="right"
								display={['none', 'none', 'none', 'inline-block']}
							>
								{usedAs === 'claim' ? (
									<HStack>
										<Button
											size={'sm'}
											as={Link}
											to={`./requests?cId=${searchParams.get('cId')}`}
											colorScheme={'green'}
										>
											GO TO CLAIMED REQUESTS
										</Button>
									</HStack>
								) : (
									<>
										{business?.status === 'pending' ||
										business?.status === 'declined' ? (
											<HStack>
												<Button
													as={Link}
													to={`/admin/business/edit/${business?.id}`}
													size={'sm'}
													colorScheme={'blue'}
												>
													EDIT
												</Button>
												<Button
													size={'sm'}
													onClick={() => openConfirmDialog('approve')}
													colorScheme={'green'}
												>
													APPROVE
												</Button>

												{business?.status !== 'declined' && (
													<Button
														size={'sm'}
														onClick={() => openConfirmDialog('decline')}
														colorScheme={'red'}
													>
														DECLINE
													</Button>
												)}
											</HStack>
										) : (
											<HStack>
												<Button
													as={Link}
													to={`/admin/business/edit/${business?.id}`}
													size={'sm'}
													colorScheme={'blue'}
												>
													EDIT
												</Button>
												<Button
													size={'sm'}
													onClick={() => openConfirmDialog('block')}
													colorScheme={'red'}
												>
													&nbsp; BLOCK &nbsp;
												</Button>
											</HStack>
										)}
									</>
								)}
							</Box>
						</Flex>

						<Stack mt="3" align={['center', 'center', 'center', 'start']}>
							{business?.website && (
								<Flex>
									<Text fontWeight={'500'}>Website: </Text>
									<Text ml={'3'} as={'a'} href={business?.website}>
										{business?.website}
									</Text>
								</Flex>
							)}

							{business?.phone && (
								<Flex>
									<Text fontWeight={'500'}>Phone: </Text>
									<Text ml={'3'}>{business?.phone}</Text>
								</Flex>
							)}

							{business?.whatsapp_no && (
								<Flex>
									<Text fontWeight={'500'}>WhatsApp: </Text>
									<Text ml={'3'}>{business?.whatsapp_no}</Text>
								</Flex>
							)}

							{business?.email && (
								<Flex>
									<Text fontWeight={'500'}>Email: </Text>
									<Text ml={'3'}>{business?.email}</Text>
								</Flex>
							)}
						</Stack>
						<Box>
							<Flex
								// ps={'6'}
								display={['flex', 'flex', 'flex', 'none']}
								justify={'center'}
								mt={'3'}
							>
								{usedAs === 'claim' ? (
									<HStack>
										<Button
											size={'sm'}
											as={Link}
											to={`./requests?cId=${searchParams.get('cId')}`}
											colorScheme={'green'}
										>
											GO TO CLAIMED REQUESTS
										</Button>
									</HStack>
								) : (
									<>
										{business?.status === 'pending' ||
										business?.status === 'declined' ? (
											<HStack>
												<Button
													as={Link}
													to={`/admin/business/edit/${business?.id}`}
													size={'sm'}
													colorScheme={'blue'}
												>
													EDIT
												</Button>
												<Button
													size={'sm'}
													onClick={() => openConfirmDialog('approve')}
													colorScheme={'green'}
												>
													APPROVE
												</Button>

												{business?.status !== 'declined' && (
													<Button
														size={'sm'}
														onClick={() => openConfirmDialog('decline')}
														colorScheme={'red'}
													>
														DECLINE
													</Button>
												)}
											</HStack>
										) : (
											<HStack justify={'center'} w={'100%'}>
												<Button
													as={Link}
													to={`/admin/business/edit/${business?.id}`}
													size={'sm'}
													colorScheme={'blue'}
												>
													EDIT
												</Button>
												<Button
													size={'sm'}
													onClick={() => openConfirmDialog('block')}
													colorScheme={'red'}
												>
													&nbsp; BLOCK &nbsp;
												</Button>
											</HStack>
										)}
									</>
								)}
							</Flex>
						</Box>
					</Box>
				</Flex>

				{business?.bio && (
					<Box mt={6}>
						<Heading as={'h4'} fontSize={'1.1rem'}>
							Company Bio
						</Heading>
						<Text mt={4}>{business.bio}</Text>
					</Box>
				)}

				{/* <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10} mt={6}> */}
				<SimpleGrid columns={{ base: 1, md: validOperatingHours?.length > 0 ? 2 : 1 }} spacing={10} mt={6}>
					{/* Left Column: Opening Hours */}
					{/* {business?.operating_hours?.length > 0 && ( */}
					{validOperatingHours?.length > 0 && (
						<Box>
							<Heading as={'h4'} fontSize={'1.1rem'}>
							Opening Hours
							</Heading>

							<Stack spacing={2} mt={4}>
								{/* {business?.operating_hours.map((item, index) => ( */}
								{validOperatingHours.map((item, index) => (
									<Text key={index} display={'flex'}>
									<Text as="span" w={'200px'} fontWeight={'500'} me={4}>
										{item.day}
									</Text>
									{item?.start_time} - {item?.end_time}
									</Text>
								))}
							</Stack>
						</Box>
					)}

					{/* Right Column: Other Info */}
					<Box>
					{/* {business?.industry && (
						<Box mb={6}>
						<Heading as={'h4'} fontSize={'1.1rem'}>
							Industry
						</Heading>
						<Text mt={4}>{business.industry?.name}</Text>
						</Box>
					)} */}
					<Box mb={6}>
										<Heading as={'h4'} fontSize={'1.1rem'}>
										Insustry
										</Heading>
										<Box mt={4}>
										{objArrToStrArr(business?.industries).join(', ')}
										</Box>
					</Box>

					<Box mb={6}>
						<Heading as={'h4'} fontSize={'1.1rem'}>
						Product Categories
						</Heading>
						<Box mt={4}>
						{objArrToStrArr(business?.product_categories).join(', ')}
						</Box>
					</Box>

					<Box mb={6}>
						<Heading as={'h4'} fontSize={'1.1rem'}>
						Products
						</Heading>
						<Box mt={4}>{objArrToStrArr(business?.products).join(', ')}</Box>
					</Box>

					{/* {business.current_status && ( */}
						<Box mb={6}>
							<Heading as={'h4'} fontSize={'1.1rem'}>
							Current Status
							</Heading>
							<Box mt={4}>{business?.current_status}</Box>
						</Box>
					{/* // )}  */}

					{/* {Array.isArray(business?.current_offers) && business.current_offers.length > 0 && ( */}
						<Box mb={6}>
							<Heading as={'h4'} fontSize={'1.1rem'}>
							Current Offers
							</Heading>
							<Box mt={4}>
							{objArrToStrArr(business?.current_offers, 'offer').join(', ')}
							</Box>
						</Box>
					{/* )} */}

					<Box mb={6}>
						<Heading as={'h4'} fontSize={'1.1rem'}>
						Pricing
						</Heading>
						<Box mt={4}>{showPricing(business?.pricing || 1)}</Box>
					</Box>
					</Box>
				</SimpleGrid>

				<Box mt={6}>
					<Heading as={'h4'} fontSize={'1.1rem'}>
						Address and GEO Location
					</Heading>

					<Box mt={4}>
						<Stack spacing={2}>
							{business?.address1 && (
								<Flex>
									<Text fontWeight={'500'} as={'span'} me={4}>
										Address 1:
									</Text>
									{business?.address1}
								</Flex>
							)}
							{business?.address2 && (
								<Flex>
									<Text fontWeight={'500'} as={'span'} me={4}>
										Address 2:
									</Text>
									{business?.address2}
								</Flex>
							)}
							{business?.city && (
								<Flex>
									<Text fontWeight={'500'} as={'span'} me={4}>
										City:
									</Text>
									{business?.city?.name}
								</Flex>
							)}
							{business?.state && (
								<Flex>
									<Text fontWeight={'500'} as={'span'} me={4}>
										State/Province:
									</Text>
									{business?.state?.name}
								</Flex>
							)}

							{business?.zip_code && (
								<Flex>
									<Text fontWeight={'500'} as={'span'} me={4}>
										Zip Code:
									</Text>
									{business?.zip_code}
								</Flex>
							)}
							{business?.country && (
								<Flex>
									<Text fontWeight={'500'} as={'span'} me={4}>
										Country:
									</Text>
									{business?.country?.name}
								</Flex>
							)}
							{/* {business?.lat && ( */}
								<Flex>
									<Text fontWeight={'500'} as={'span'} me={4}>
										Latitude:
									</Text>
									{business?.lat}
								</Flex>
							{/* )} */}
							{/* {business?.long && ( */}
								<Flex>
									<Text fontWeight={'500'} as={'span'} me={4}>
										Longitude:
									</Text>
									{business?.long}
								</Flex>
							{/* )} */}
						</Stack>
					</Box>
				</Box>

				<Box mt={6}>
					<Heading as={'h4'} fontSize={'1.1rem'}>
						Social
					</Heading>

					<List mt={'4'} spacing={3}>
						{business?.facebook && (
							<ListItem>
								<ListIcon as={FaFacebook} color="facebook.500" />
								{business?.facebook}
							</ListItem>
						)}

						{business?.twitter && (
							<ListItem>
								<ListIcon as={FaTwitter} color="twitter.500" />
								{business?.twitter}
							</ListItem>
						)}
						{business?.youtube && (
							<ListItem>
								<ListIcon as={FaYoutube} color="red.500" />
								{business?.youtube}
							</ListItem>
						)}
						{business?.instagram && (
							<ListItem>
								<ListIcon as={FaInstagram} color="purple.500" />
								{business?.instagram}
							</ListItem>
						)}
						{business?.linkedin && (
							<ListItem>
								<ListIcon as={FaLinkedin} color="linkedin.500" />
								{business?.linkedin}
							</ListItem>
						)}
					</List>
				</Box>
			</Box>
		</>
	)
}

export default AdminBusinessDetails
